import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import EditableSelectField from 'components/forms/editableSelectField';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Row from 'components/Row';
import Col from 'components/Col';
import moment from 'moment';

const closedKey = 'CLOSED';

let _options = {};

function getOptions(locale) {
  if (_options[locale]) {
    return _options[locale];
  }

  let _hourSelectOptions = [];
  let startTime = moment.utc(0);

  for (let i = 0; i < 48; ++i) {
    _hourSelectOptions.push([startTime.format('h:mm a'), startTime.format('LT')]);
    startTime.add(30, 'minutes');
  }

  _options[locale] = _hourSelectOptions;
  return _hourSelectOptions;
}

const dateFilter = (start, locale) => {
  return (x, i) => {
    let startPos = getOptions(locale).map(y => y[0]).indexOf(start) + 1;

    return start !== closedKey && !!start && i > startPos && x[0] !== closedKey ||
      (start === closedKey || !start) && x[0] === closedKey;
  };
};

const HoursSelect = ({date, store, hoursChange, edit, intl}) => {
  let closed = intl.formatMessage({id: 'general.closed'}).toUpperCase();
  const [day, time] = date.split('.');
  const value = store.hours[day][time];

  const hourSelectOptions = [[closedKey, closed]].concat(getOptions());

  const options = time === 'start' ?
    hourSelectOptions :
    hourSelectOptions.filter(dateFilter(store.hours[day]['start'], intl.locale));

  return <EditableSelectField
    value={value || closed}
    dataKey={date}
    key={date}
    keys={options.map(x => x[0])}
    options={options.map(x => x[1])}
    optionsChange={true}
    onChange={hoursChange}
    editMode={edit} />;
};

HoursSelect.propTypes = {
  date: PropTypes.string,
  edit: PropTypes.bool,
  hoursChange: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
};

const Day = ({day, store, edit, hoursChange, intl}) => {
  return <tr key={'day.' + day}>
    <td>{day ? intl.formatMessage({id: 'general.day.' + day.toLowerCase()}) : ''}</td>
    <td><HoursSelect date={day + '.start'} store={store} edit={edit} hoursChange={hoursChange}
                     intl={intl}/></td>
    <td><HoursSelect date={day + '.end'} store={store} edit={edit} hoursChange={hoursChange}
                     intl={intl}/></td>
  </tr>;
};

Day.propTypes = {
  day: PropTypes.number,
  edit: PropTypes.bool,
  hoursChange: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  intl: intlShape,
};

class StoreHours extends PureComponent {
  render() {

    const {store, edit, hoursChange, intl} = this.props;
    let days = Object.keys(store.hours)
      .map((x, i) => <Day day={x} store={store} hoursChange={hoursChange} edit={edit} key={x + '|' + i}
                          intl={intl}/>);

    return <div>
      <h2 className='with-keyline'><FormattedMessage id="preferences.store.hours"/></h2>
      <Row>
        <Col xs={12}>
          <table className='table-biolab'>
            <thead>
              <tr>
                <th><FormattedMessage id='general.day.week'/></th>
                <th><FormattedMessage id='general.open'/></th>
                <th><FormattedMessage id='general.close'/></th>
              </tr>
            </thead>
            <tbody>
              {days}
            </tbody>
          </table>
        </Col>
      </Row>
    </div>;
  }
}

StoreHours.propTypes = {
  edit: PropTypes.bool,
  hoursChange: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  intl: intlShape,
};

export default injectIntl(StoreHours);
